import { compare, DisplayDate } from 'owa-datetime';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';
import { selectedDateUpdated } from './selectedDateUpdated';

export let updateSelectedDate = action('updateSelectedDate')(function updateSelectedDate(
    newValue: DisplayDate,
    store: CalendarSurfaceStore
) {
    if (compare(store.selectedDate, newValue) != 0) {
        store.selectedDate = newValue;
        selectedDateUpdated(store.selectedDate);
    }
});
